import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';
import { Notifications as SharedNotifications } from '@betterment/shared-components';

type Props = {
  css?: SystemStyleObject;
};

export function Notifications({ css: cssProp }: Props) {
  return (
    <Box css={cssProp}>
      <SharedNotifications
        css={{
          marginTop: {
            base: 'space.300',
            mdDown: 'space.100',
          },
        }}
      />
    </Box>
  );
}
